import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { IQObservationService } from '../../core/services/iq-observation';
import {
  getIQObservations,
  getIQObservationsFail,
  getIQObservationsSuccess,
} from '../actions/get-iq-observations.action';

@Injectable()
export class IQObservationEffects {
  private readonly concreteService$ = inject(IQObservationService);

  private readonly actions$ = inject(Actions);

  getIQObservations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getIQObservations),
      switchMap(({ showMockData }) =>
        this.concreteService$.getObservations({ showMockData }).pipe(
          map((observations) => getIQObservationsSuccess({ observations })),
          catchError((error) => of(getIQObservationsFail({ error }))),
        ),
      ),
    ),
  );
}
